import environment from "../environment/environment";

// Get the base URL from environment variables or fallback to default
const baseUrl = environment.baseUrl;

const api = {
  /**
   * The API endpoint for adding register information.
   * @type {string}
   */
  register: `${baseUrl}subscribe`,

  /**
   * The API endpoint for fetching configuration data.
   * @type {string}
   */
  configs: `${baseUrl}configs`,

  /**
   * The API endpoints for lands.
   * @type {object}
   */
  lands: {
    /**
     * The API endpoint for fetching lands list.
     * @type {string}
     */
    list: `${baseUrl}lands`,

    /**
     * The API endpoint for fetching land details.
     * @param {number} id - The ID of the land to fetch.
     * @returns {string} The API endpoint for fetching land details.
     */
    detail: (id: number): string => `${baseUrl}lands/${id}`,

    /**
     * The API endpoint for fetching featured lands.
     * @type {string}
     */
    featured: `${baseUrl}lands?all=1`,
  },
};

export default api;
